import { Grid } from '@mui/material';
import { BASE_FEE_ADDR, L1_FEE_ADDR, SEQUENCER_FEE_ADDR } from 'pages/raas/constants/addresses';
import {
  IUseBatchBalances,
  useBatchBalances,
} from 'pages/raas/DeploymentDetails/hooks/useBatchBalances';
import { getTokenSymbol } from 'pages/raas/DeploymentDetails/utils';
import { RollupType } from 'pages/raas/helpers/labels';
import { useRaasDeployment } from 'pages/raas/hooks';
import React, { useMemo } from 'react';
import { MetricWidget } from 'shared/components/metric/MetricWidget';
import { Section } from 'shared/components/Section';
import { formatWithPrecision } from 'shared/utils/strings';

export const OverviewSection = () => {
  const { data: rollup } = useRaasDeployment();

  const accounts: IUseBatchBalances['accounts'] = useMemo(() => {
    const orbitAccountslabelMap = {
      batchPosterFeeCollector: 'Batch Poster Fee Collector',
      infrastructureFeeCollector: 'Infrastructure Fee Collector',
      l1RewardsRecipient: 'L1 Rewards Recipient',
      networkFeeReceiver: 'Network Fee Receiver',
    };

    if (rollup?.type === RollupType.ORBIT) {
      return Object.entries(orbitAccountslabelMap).map(([key, label]) => ({
        label,
        account: rollup?.accounts?.[key as keyof typeof rollup.accounts],
      }));
    }

    return [
      { label: 'Base Fee Balance', account: BASE_FEE_ADDR },
      { label: 'L1 Fee Balance', account: L1_FEE_ADDR },
      { label: 'Sequencer Fee Balance', account: SEQUENCER_FEE_ADDR },
    ];
  }, [rollup]);

  const { data: balances, isPending: getBalancesPending } = useBatchBalances({
    viem: false,
    accounts,
    rollup,
  });

  return (
    <Section
      renderContent={
        <Grid container>
          {!balances || getBalancesPending
            ? accounts.map(v => (
                <MetricWidget key={typeof v === 'string' ? v : v.account} loading tooltip="..." />
              ))
            : balances.map(({ account, balance, label }) =>
                balance !== undefined ? (
                  <MetricWidget
                    key={account}
                    label={label}
                    tooltip={`Balance in ${getTokenSymbol(rollup)} for account ${account}`}
                    value={+formatWithPrecision(balance)}
                    valueSuffix={getTokenSymbol(rollup)}
                  />
                ) : null,
              )}
        </Grid>
      }
      title="Fee vault balance"
    />
  );
};
